import { useAuthStore } from '@/store/authStore';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const { admin, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <header className="h-14 bg-admin-header border-b border-admin-border flex items-center justify-between px-6">
      <div />
      <div className="flex items-center gap-4">
        <span className="text-sm text-slate-600">{admin?.email ?? ''}</span>
        <button
          onClick={handleLogout}
          className="text-sm text-slate-500 hover:text-admin-danger transition-colors"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
